import React, { useEffect } from "react";
import { Icon } from "./CreateIcons.jsx";
import ThurentEventForm from "../redesign/components/ThurentEventForm";
import { CssBaseline, Stack, IconButton } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import "./aboutpage_module.css";
import { getProviderServices } from "../util/providerServices";
import CreateEventCTA from "./EventServices/CreateEventCTA";
import { homePagePath } from "../constant";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import icon1 from "../assets/images/icon 9/Group 165.png";
import icon2 from "../assets/images/icon 9/Group 167.png";
import icon3 from "../assets/images/icon 9/handshake.png";
import icon4 from "../assets/images/icon 9/visibility.png";
import nick from "../assets/images/icon 8/nickimage.jpeg";
import rasheed from "../assets/images/icon 8/rasheedimage.jpeg";

const Services = getProviderServices();

export const Aboutuspage = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const role = useSelector((state) => state.auth.role);

  const backtoHome = () => {
    isLoggedIn
      ? role === "customer"
        ? navigate("/dashboard")
        : navigate("/service-provider/dashboard")
      : navigate(homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />

      <div className={`main-container-aboutus ${!isLoggedIn && "no-auth"}`}>
        <div className="frontend-container-aboutus">
          {(!isLoggedIn || (isLoggedIn && role === "customer")) && (
            <div className="header-container-contact">
              <div className="event-service-list-contact sidebar">
                {Services.length > 0 &&
                  Services.map((item) => (
                    <Link
                      key={item.id}
                      className="event-service-list-link sidebar"
                      to={`/service/${item.slug}`}
                    >
                      <div className="event-service-button-data">
                        <div className="event-services-buttons-icons">
                          <Icon id={item.id} className="icon-default-color" />

                          <div>
                            <span>{item.serviceCardName}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>
            </div>
          )}
          <div className="founders-heading" style={{ textAlign: 'center', marginTop: '20px' }}>
            <h2>Meet Our Founders</h2>
          </div>
          <div
            className="founders-container"
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '30px',
              flexWrap: 'wrap',
              marginTop: '20px',
              padding: '0 20px',
            }}
          >
            <div
              style={{
                width: '400px',
                maxWidth: '100%',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                textAlign: 'left',
              }}
            >
              <img
                src={nick}
                alt="Nick Kondoori"
                width="100%"
                height="330px"
                style={{ objectFit: 'cover', display: 'block' }}
              />
              <div style={{ padding: '20px' }}>
                <h3 style={{ margin: '0 0 4px 0' }}>Nagesh Kondoori (Nick)</h3>
                <p style={{ color: '#26B8E3', fontWeight: 600, margin: '0 0 16px 0' }}>
                  Founder &amp; CTO
                </p>
                <p style={{ margin: 0, lineHeight: 1.6, color: '#333' }}>
                  Nick leads Thurent's product and technology. He built the platform
                  that turns event chaos into coordination stitching together
                  checklists, vetted providers, booking workflows, and clear pricing so
                  hosts can plan and order everything from one place. A product and
                  engineering leader with 15+ years building software, he specializes
                  in turning emerging AI into practical features people actually use,
                  keeping Thurent fast, intelligent, and genuinely useful at every step
                  of the host's journey.
                </p>
              </div>
            </div>

            <div
              style={{
                width: '400px',
                maxWidth: '100%',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                textAlign: 'left',
              }}
            >
              <img
                src={rasheed}
                alt="Armstead Rasheed King III"
                width="100%"
                height="330px"
                style={{ objectFit: 'cover', objectPosition: 'top', display: 'block' }}
              />
              <div style={{ padding: '20px' }}>
                <h3 style={{ margin: '0 0 4px 0' }}>Armstead Rasheed King III</h3>
                <p style={{ color: '#26B8E3', fontWeight: 600, margin: '0 0 16px 0' }}>
                  Co-Founder &amp; CEO
                </p>
                <p style={{ margin: 0, lineHeight: 1.6, color: '#333' }}>
                  Armstead leads Thurent's vision, strategy, and growth. He built
                  Thurent to bring order and calm to one of life's most stressful
                  undertakings hosting turning a fragmented, offline process into
                  one clear, guided, end-to-end experience. He brings a track record
                  of leading complex programs and turning struggling teams into
                  high-performing ones, with deep expertise in Agile delivery, program
                  management, and operational execution under pressure. That
                  operator's discipline is the engine behind how Thurent is built and
                  how it scales: focused, accountable, and relentlessly oriented
                  around getting things done for hosts.
                </p>
              </div>
            </div>
          </div>

          <div className="event-form-inner">
            <div
              className={`event-form-body ${isLoggedIn && role === "provider" ? "alter full" : "list"
                }`}
            >
              <div className="event-form-body-inner">
                <div
                  className="event-form-content event-service-content"
                  style={{ width: "100%" }}
                >
                  <div className="event-service-data-about">
                    <div className="blackbackgroundbody">
                      <span className="aboutus_headders">Our Story</span>
                      <p className="about_us_para1">
                        Thurent started with a simple problem: planning a home event should not feel like managing a dozen vendors.
                      </p>
                      <p className="about_us_para1">
                        When Nagesh (Nick) Kondoori was planning an event at home, he found himself coordinating tents, catering, priests, rentals, and other services, each with its own process, timelines, and questions. The challenge was not finding vendors. It was figuring out how everything fit together.
                      </p>
                      <p className="about_us_para1">
                        That experience led to a simple realization: <strong>hosts do not need more choices. They need a better way to coordinate them.</strong>
                      </p>
                      <p className="about_us_para1">
                        Nick founded Thurent to make that process easier. Thurent brings together the planning steps, trusted local service providers, bookings, checklists, and pricing in one place, helping hosts know what they need, when they need it, and what to do next.
                      </p>
                      <p className="about_us_para1">
                        We think of Thurent as an <strong>event copilot</strong>: practical, local, and designed to take the coordination off your plate.
                      </p>
                      <p className="about_us_para1">
                        Because hosting an event at home should be about bringing people together, not chasing vendors and managing logistics.
                      </p>
                    </div>

                    <div className="bodytext">
                      <span className="showimage_with_header"> <span><img src={icon1} /></span> Our Mission</span>
                      <p className="about_us_para">
                        To empower hosts with confidence, clarity, and convenience they need to organize events at home
                        by connecting them to reliable local service providers and guiding them step-by-step through the entire journey.
                      </p>
                    </div>
                    <div className="bodytext">
                      <span className="showimage_with_header"><span ><img className="aboutus_headders2" src={icon2} /></span> What We Do</span>
                      <p className="about_us_para">
                        Thurent simplifies every part of hosting:
                        Plan: Get a personalized event checklist tailored to your occasion whether it’s a housewarming, pooja, birthday, or anniversary.
                        Connect: Browse and book verified local providers for tents, catering, decoration, priests, and more all in one place.
                        Coordinate: Follow a clear, guided workflow to ensure nothing is missed from pre-event preparation to the final wrap-up.
                      </p>
                    </div>
                    <div className="bodytext">
                      <span className="showimage_with_header"><span ><img className="aboutus_headders2" src={icon3} /></span> Why We Exist</span>
                      <p className="about_us_para">
                        Hosting an event at home should feel joyful, not stressful. Thurent bridges the gap between tradition and
                        technology making it easy for families to focus on what truly matters: celebrating together.
                      </p>
                    </div>
                    <div className="bodytext">
                      <span className="showimage_with_header"><span ><img className="aboutus_headders2" src={icon4} /></span> Our Vision</span>
                      <p className="about_us_para">
                        To become the most trusted event-hosting companion for every household blending community, culture, and convenience into one seamless experience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="create-event"> */}
              {/* <CreateEventCTA /> */}
              {/* <ThurentEventForm />
                    </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ConfirmDialog />
    </div>
  );
};
export default Aboutuspage;